import React from 'react';
import { Avatar as Avtr } from 'antd';

/**
 * AvatarGroup component that renders a group of avatars with different size options
 *
 * {@link https://ant.design/components/avatar#avatar}
 *
 * @module AvatarGroup
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child elements to render inside the avatar group
 * @param {string} [props.className] - Additional CSS class name
 * @param {string} [props.size='48'] - Size of the avatars ('mini', 'small', 'medium', 'large') or an integer in px
 * @returns {React.ReactElement} Rendered AvatarGroup component
 */
const AvatarGroup = ( { children, ...props } ) => {
    const { className, size } = props;
    switch ( size ) {
        case 'mini':
            return <Avtr.Group max={ { count: 4 } } className={ className ? `mini-avatar ${ className }` : 'mini-avatar' }  { ...props } size={ 24 }>
                { children }
            </Avtr.Group>;
        case 'small':
            return <Avtr.Group max={ { count: 4 } } className={ className ? `small-avatar ${ className }` : 'small-avatar' } { ...props } size={ 36 }>
                { children }
            </Avtr.Group>;
        case 'medium':
            return <Avtr.Group max={ { count: 4 } } className={ className ? `medium-avatar ${ className }` : 'medium-avatar' } { ...props } size={ 48 }>
                { children }
            </Avtr.Group>;
        case 'large':
            return <Avtr.Group max={ { count: 4 } } className={ className ? `large-avatar ${ className }` : 'large-avatar' } { ...props } size={ 64 }>
                { children }
            </Avtr.Group>;
        default:
            return <Avtr.Group max={ { count: 4 } } size={ 48 } className={ className ? `avatar ${ className }` : 'avatar' } { ...props }>
                { children }
            </Avtr.Group>;
    }
};

export  default AvatarGroup;


